import { useAuth } from "../auth/AuthContext";
import { ROLE_LABEL, avatarColor } from "../utils/format";

interface TopbarProps {
  connected: boolean;
  alertCount: number;
  onBellClick: () => void;
  /** 是否展示「一键建会」入口（仅管理员） */
  canQuickCreate: boolean;
  onQuickCreate: () => void;
}

export function Topbar({ connected, alertCount, onBellClick, canQuickCreate, onQuickCreate }: TopbarProps) {
  const { user, logout } = useAuth();

  return (
    <header className="topbar">
      <div className="logo">
        <div className="logo-icon" aria-hidden="true">
          📅
        </div>
        <div className="logo-text">
          会议效能监测与议程跟进平台
          <span className="logo-sub">MEETING EFFICIENCY &amp; AGENDA TRACKING PLATFORM</span>
        </div>
      </div>
      <nav className="nav" aria-label="页面导航">
        <a href="#secDetect">会议检测</a>
        <a href="#secArchive">纪要归档</a>
        <a href="#secFollow">议程跟进</a>
      </nav>
      <div className="top-right">
        {canQuickCreate && (
          <button className="btn-quick-create" onClick={onQuickCreate} title="按组织架构创建周期会议">
            ＋ 一键建会
          </button>
        )}
        <div className="env" title={connected ? "实时推送已连接" : "正在重连…"}>
          <span className={`dot${connected ? "" : " warn"}`} />
          {connected ? "实时监测中" : "重连中"}
        </div>
        <button
          className="bell"
          onClick={onBellClick}
          title="会议未开启提醒"
          aria-label={`会议未开启提醒，当前 ${alertCount} 条`}
        >
          🔔
          {alertCount > 0 && <span className="n">{alertCount}</span>}
        </button>
        {user && (
          <div className="user-chip" title={`${user.name}（${ROLE_LABEL[user.role] ?? user.role}${user.deptName ? ` · ${user.deptName}` : ""}）`}>
            <div className="avatar avatar-sm" style={{ background: avatarColor(user.name) }}>
              {user.name[0]}
            </div>
            <div className="u-text">
              <div>{user.name}</div>
              <div className="role">
                {ROLE_LABEL[user.role] ?? user.role}
                {user.deptName ? ` · ${user.deptName}` : ""}
              </div>
            </div>
          </div>
        )}
        <button className="btn-ghost" onClick={() => void logout()}>
          退出
        </button>
      </div>
    </header>
  );
}
